module.exports = __webpack_public_path__ + "static/img/screenbj.51d36393.jpg";